export default __webpack_public_path__ + "static/leftFrontShape-7a253da362f314dd8a0d42428566c106.png";